import { yup } from '@framework/validation';
import { RuleType } from '../../IRule';
import { IRuleType } from '../../IRuleType';
import { LengthRangeRuleComponent } from './LengthRangeRuleComponent';

const LengthRuleSchema = yup
  .object({
    min: yup.number().notRequired().min(0).label('Lunghezza minima'),
    max: yup
      .number()
      .notRequired()
      .positive()
      .greaterThan('min')
      .label('Lunghezza massima'),
    minCustomMessage: yup
      .string()
      .notRequired()
      .label('Messaggio personalizzato di validazione'),
    maxCustomMessage: yup
      .string()
      .notRequired()
      .label('Messaggio personalizzato di validazione'),
  })
  .notRequired()
  .noUnknown();

export type ILenghtRangeRuleOptions = yup.InferType<typeof LengthRuleSchema>;

export const LengthRangeRule: IRuleType<ILenghtRangeRuleOptions> = {
  type: RuleType.LengthRange,
  name: 'Lunghezza',
  configComponent: LengthRangeRuleComponent,
  configValidator: LengthRuleSchema,
  validator: (schema, rule) => {
    if (!rule) return schema;

    if (rule.min != null) {
      schema = (schema as yup.StringSchema).min(
        rule.min,
        rule.minCustomMessage ?? undefined,
      );
    }

    if (rule.max != null) {
      schema = (schema as yup.StringSchema).max(
        rule.max,
        rule.maxCustomMessage ?? undefined,
      );
    }

    return schema;
  },
};
